module.exports = __webpack_public_path__ + "img/813e663c8d5b6ad0f8f94eeb33ae0457.7d1625c5.jpg";